import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import type { RewardsConfig } from "../hooks/use-rewards-config";

export function LoyaltyProgramToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<RewardsConfig>;
  saving: boolean;
}) {
  const { control } = useFormContext<RewardsConfig>();
  const { t } = useTranslation("settings");

  return (
    <FormField
      control={control}
      name="loyaltyProgramEnabled"
      render={({ field }) => (
        <FormItem>
          <SettingField
            label={t("rewards.fields.loyaltyProgram.label")}
            helpText={t("rewards.fields.loyaltyProgram.helpText")}
            helpDetails={
              <div className="space-y-2">
                <div className="text-sm font-medium text-foreground">
                  {t("rewards.fields.loyaltyProgram.helpDetails.title")}
                </div>
                <ul className="text-sm space-y-1 text-muted-foreground">
                  {(
                    t("rewards.fields.loyaltyProgram.helpDetails.benefits", {
                      returnObjects: true,
                    }) as string[]
                  ).map((benefit: string, index: number) => (
                    <li key={index}>• {benefit}</li>
                  ))}
                </ul>
              </div>
            }
          >
            <FormControl>
              <Switch
                checked={field.value}
                disabled={saving}
                onCheckedChange={(value) => {
                  void saveField("loyaltyProgramEnabled", value);
                }}
              />
            </FormControl>
          </SettingField>
        </FormItem>
      )}
    />
  );
}
